import React from 'react';
import { Table } from 'reactstrap';
import { useTranslator, formatCalories, formatDecimal } from '@front-activerse/common-components';

interface ICookbookNutritions {
  meal: any;
  multiplier: number;
}

export const CookbookNutritions: React.FC<ICookbookNutritions> = ({ meal, multiplier }) => {
  const { t } = useTranslator();
  const singleServingFiber: number = meal.nutrition.singleServing.dietaryFiberGrams ?? 0;
  const allServingsFiber: number = meal.nutrition.allServings?.dietaryFiberGrams ?? 0;

  return (
    <div className="table-wrapper">
      <Table>
        <thead>
          <tr>
            <th></th>
            <th>
              {(meal.nutrition.allServings || multiplier > 1) &&
                t('mealDetails.macrosTable.allServings')}
            </th>
            <th>{t('mealDetails.macrosTable.oneServing')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">{t('mealDetails.macros.calories.title')}</th>
            <td>
              {meal.nutrition.allServings ? (
                <>{formatCalories(meal.nutrition.allServings.kcal * multiplier)} kcal</>
              ) : (
                multiplier > 1 &&
                `${formatCalories(meal.nutrition.singleServing.kcal * multiplier)} kcal`
              )}
            </td>
            <td>{formatCalories(meal.nutrition.singleServing.kcal)} kcal</td>
          </tr>
          <tr>
            <th scope="row">{t('mealDetails.macrosTable.proteins.title')}</th>
            <td>
              {meal.nutrition.allServings ? (
                <>{meal.nutrition.allServings.protein.grams * multiplier} g</>
              ) : (
                multiplier > 1 && `${meal.nutrition.singleServing.protein.grams * multiplier} g`
              )}
            </td>
            <td>{meal.nutrition.singleServing.protein.grams} g</td>
          </tr>
          <tr>
            <th scope="row">{t('mealDetails.macrosTable.fats.title')}</th>
            <td>
              {meal.nutrition.allServings ? (
                <>{meal.nutrition.allServings.fat.grams * multiplier} g</>
              ) : (
                multiplier > 1 && `${meal.nutrition.singleServing.fat.grams * multiplier} g`
              )}
            </td>
            <td>{meal.nutrition.singleServing.fat.grams} g</td>
          </tr>
          <tr>
            <th>{t('mealDetails.macrosTable.carbs.title')}</th>
            <td>
              {meal.nutrition.allServings ? (
                <>{meal.nutrition.allServings.carbohydrates.grams * multiplier} g</>
              ) : (
                multiplier > 1 &&
                `${meal.nutrition.singleServing.carbohydrates.grams * multiplier} g`
              )}
            </td>
            <td>{meal.nutrition.singleServing.carbohydrates.grams} g</td>
          </tr>
          {Math.round(singleServingFiber * 10) > 0 && (
            <tr>
              <th scope="row">{t('mealDetails.macrosTable.fiber.title')}</th>
              <td>
                {meal.nutrition.allServings ? (
                  <>{formatDecimal(allServingsFiber * multiplier)} g</>
                ) : (
                  multiplier > 1 && `${formatDecimal(singleServingFiber * multiplier)} g`
                )}
              </td>
              <td>{formatDecimal(singleServingFiber)} g</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CookbookNutritions;
